import React from "react";
import FixedAssetsInventoriesGenericSkeleton from "./FixedAssetsInventoriesGenericSkeleton";

function FixedAssetsInventoriesDetailsSkeleton() {
  return (
    <>
      <FixedAssetsInventoriesGenericSkeleton />
    </>
  );
}

export default FixedAssetsInventoriesDetailsSkeleton;
